import { ApiUtility } from "./ApiUtility";
import { notifyFavoriteMutation } from "../utils/favoriteFeedback";

class VivekService {
  vaniRoute = "/api/vivekvanis?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  languagebyid = "/api/languages/";
  vivekdetailRoute = "/api/VivekVanis/";
  faviroute = "/api/VivekVanis/";
  categories = "/api/VivekVanis/Categories";

  getFilters = (productFor: string) => {
    return ApiUtility.get(
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor
    );
  };

  getVanis = (
    start: number,
    length: number,
    categoryId: string,
    IsChildLiterature: boolean,
    sort: string,
    authorId: string,
    search: string,
    langId: string,
    isSpecial: boolean
  ) => {
    return ApiUtility.get(
      this.vaniRoute +
      localStorage.getItem("lan") +
      "&search=" +
      search +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&sort=" +
      sort +
      "&authorId=" +
      authorId +
      "&bookLangauge=" +
      langId +
      "&isSpecial=" +
      isSpecial
    );
  };


  // vivek vani details

  getVivekVaniDetail = (id: string) => {
    return ApiUtility.get(
      this.vivekdetailRoute +
      id +
      "?lang=" +
      localStorage.getItem("lan")
    );
  };

    getVivekVaniDetails = (id: string) => {
    const lang = localStorage.getItem("lan") || "hindi";
    return ApiUtility.get(`${this.vivekdetailRoute}${id}/SEO?lang=${lang}`);
  };
  
  getRelatedVivekVanis = (id: string, lang: string, authorId: string) => {
    if (id === "") {
      id = "null";
    }
    return ApiUtility.get(
      this.vivekdetailRoute +
      id +
      "/related?lang=" +
      localStorage.getItem("lan") +
      "&authorId=" +
      authorId
    );
  };

    GetLanguageDataById(id: string) {
    return ApiUtility.get(
      this.languagebyid + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  // New method for resolving category by ID or slug
  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/VivekVanis/Categories/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  // New method for resolving author by ID or slug
  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/VivekVanis/Authors/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  addFavourite = (id: string) => notifyFavoriteMutation(ApiUtility.post(`/api/VivekVanis/${id}/favourite`, {}), "vivekvani", "added");

  removeFavourite = (id: string) => notifyFavoriteMutation(ApiUtility.delete(`/api/VivekVanis/${id}/favourite`), "vivekvani", "removed");

  // Fetch navigation details (TOC + lastPosition CFI)
  getNavigationDetails = (vivekVaniId: string) => {
    const payload = { vivekVaniId };
    return ApiUtility.post(`/api/VivekVanis/navigation-details`, payload);
  };

  getVaniById(id: any, userId: any) {
    const url = `${this.vivekdetailRoute}${id}?UserId=${userId}`;
    return ApiUtility.get(url);
  }

  VikekDetailService = (id: string, userId: string) => {
    return ApiUtility.get(
      this.vivekdetailRoute +
      id +
      "?UserId=" +
      userId +
      "&lang=" +
      localStorage.getItem("lan")
    );
  };

  getCategories = (lang?: string) => {
    let url = this.categories;
    if (lang) {
      url += `?lang=${lang}`;
    }
    return ApiUtility.get(url);
  };

}
export default new VivekService();
